// eslint-disable-next-line jira/filename-case
import React, { type ComponentType } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { ReactGadgetProps } from '@jira/global-pages__dashboard-react-gadgets-common/src/types.tsx';
import { FilterResultsEditSkeleton } from '@jira/platform__skeletons/src/ui/dashboard/components/filter-results-edit.tsx';
import { lazyForPaint, type PreloadPriority } from '@atlassian/react-loosely-lazy';
import type { Cleanup } from '@atlassian/react-loosely-lazy/cleanup';
import type { IssueTableGadgetEditData } from '../../../types.tsx';

const LazyIssuesInProgressGadgetEdit = lazyForPaint<
	ComponentType<ReactGadgetProps<IssueTableGadgetEditData>>
>(() => import(/* webpackChunkName: "async-react-issues-in-progress-gadget-edit" */ './main.tsx'));

export const IssuesInProgressGadgetEdit = (
	props: ReactGadgetProps<IssueTableGadgetEditData>,
): React.JSX.Element => (
	<Placeholder name="issues-in-progress-gadget-edit" fallback={<FilterResultsEditSkeleton />}>
		<LazyIssuesInProgressGadgetEdit {...props} />
	</Placeholder>
);

export const preload: (priority?: PreloadPriority) => Cleanup =
	LazyIssuesInProgressGadgetEdit.preload;
